import { RefreshTokenResponse } from '../refreshtoken';

export async function refreshToken(cognitoUsername: string): Promise<RefreshTokenResponse> {
    const params = new URLSearchParams(window.location.search);
    const staging = params.get('stagingEnv') === 'true';

    let baseUrl = "https://api.precisca.ai/authservice/refresh_token";
    if (staging) {
        baseUrl = `${baseUrl}-staging`;
    }

    const url = `${baseUrl}?username=${encodeURIComponent(cognitoUsername)}`;

    const response = await fetch(
        url, {
        method: 'GET',
        credentials: 'include', // Necessary to send the HttpOnly cookie
    }
    );

    if (response.status !== 200) {
        throw new Error(`Unable to refresh token! Status: ${response.status}`);
    }

    const encodedByteString = await response.text();
    const decodedByteString = atob(encodedByteString);
    const decodedBytes = new Uint8Array(decodedByteString.length);
    for (let i = 0; i < decodedByteString.length; i++) {
        decodedBytes[i] = decodedByteString.charCodeAt(i);
    }

    return RefreshTokenResponse.decode(decodedBytes);
}
